// src/pages/History/20thCentury/AfricanIndependenceGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/20th_Century_-_African_Independence_Movements.png';

function HistoryPageAfricanIndependenceGo() {
  return (
    <QuizPage
      title="History: African Independence Movements"
      subTopic="African Independence Movements"
      backgroundImage={historyImage}
      returnPath="/History-African-Independence"
    />
  );
}

export default HistoryPageAfricanIndependenceGo;
